import React, { useContext } from 'react';

export type LegendDimension = {
    key: string | null;
    dimensionValues: string[];
    translations?: Record<string, string | undefined>;
};

type LegendDimensionContextType = {
    legendDimension: LegendDimension;
    setLegendDimension: React.Dispatch<React.SetStateAction<LegendDimension>>;
};

const initialContext: LegendDimensionContextType = {
    legendDimension: { key: null, dimensionValues: [] },
    setLegendDimension: () => {},
};
const LegendDimensionContext =
    React.createContext<LegendDimensionContextType>(initialContext);

export const useLegendDimensionContext = () =>
    useContext(LegendDimensionContext);

export default LegendDimensionContext;
